/**
 * Route for `publisher-performance-report`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublisherPerformanceReportPage } from "../features/publisher-performance-report/PublisherPerformanceReportPage";

export const publisherPerformanceReportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publisher-performance-report",
	component: PublisherPerformanceReportPage,
});

export default publisherPerformanceReportRoute;
